export default __webpack_public_path__ + "static/orta-therox-8fd1d8b82c6a5ae8b9da5140580fbebe.jpg";